module.exports = __webpack_public_path__ + "img/item_Character_fluid_03a.fc1306b6.gif";